import { animated } from "@react-spring/web";
import { useDrag } from "@use-gesture/react";
import React, {useRef } from "react";
import { ANNOTATOR_TOOL_LABELS_HEIGHT } from "../tools/Contants";
import { PlaceNameStatsItem } from "../objects/PlaceNameStats.interface";
import { Entity } from "../objects/Entity.interface";


export type ToolLabelListProps = {
    EntityList: Entity[],
    activeDrag: boolean,
    height: number,
    heightSaved:number,
    containerRef: HTMLDivElement | null,
    dropdownToolRef: HTMLButtonElement | null,
    setStatus: (activeDrag: boolean, height: number) => void,
    handleFieldListStatus: (entityId:number, fieldListKey: string) => void,
    showFieldStats : (fieldCode:string) => number,
    getPlaceNameStats : (fieldCode:string) => PlaceNameStatsItem[],
    handleLabelSelected : (placeName:string, fieldCode:string, entityCode:string) => void
    
}

export default function ToolLabelList (props: ToolLabelListProps){
    const contentRef = useRef<HTMLDivElement | null>(null);

    const setDetailsToolHeight = (height:number) =>{
        sessionStorage.setItem(ANNOTATOR_TOOL_LABELS_HEIGHT, height.toString());
    }

    const bindHandleToolPosition = useDrag((params) => {
            
        if(props.dropdownToolRef != null){  
            const containerHeight = contentRef.current?.clientHeight;
            props.setStatus(params.active, params.offset[1]);
            
            if(containerHeight != undefined){
                setDetailsToolHeight(containerHeight);
            }
        }
    },{
        from: (event) =>{
            return [0,props.height];
        },
        bounds: (state) => {
            if(props.containerRef != null){
                const containerHeight = props.containerRef!.clientHeight ?? 0;
                const detailsHeight = containerHeight - props.height;
                return{
                    bottom: detailsHeight
                }
            }else
            {
                return{}
            }
            
        }
    });

    const handleLabelListStatus =  (fieldId:String, listId:string) => {
        // Check if user has entered the file
        let entityListEmptyDOMElement = document.getElementById(listId + fieldId);
        if(entityListEmptyDOMElement)
        {
            if(entityListEmptyDOMElement.style.display === "block")
                entityListEmptyDOMElement.style.display = "none";
            else
                entityListEmptyDOMElement.style.display = "block";
        }
    }

    return(
        <animated.div ref={contentRef}  style={{ height: (props.activeDrag)?props.height:props.heightSaved}}  className="sub-container" {...bindHandleToolPosition()}>
                        
            <div className="area-entities-counter-list">
                {
                
                    props.EntityList.map((entity) => (
                            <div className="area-entity-item-container">
                                <div className="area-entity-item">
                                    
                                    <div className="area-entity-circle" style={{background: entity.Color}}></div>
                                    <div className="area-entity-data"><span className="area-entity-label">{entity.Entity}</span> </div>
                                    <span onClick={() => props.handleFieldListStatus(entity.id!,'FieldList_Counter_')} className="material-symbols-outlined  arrow-field-list">
                                                arrow_drop_up
                                                </span>
                                </div>

                                <div id= {'FieldList_Counter_' + entity.id?.toString()} className="area-entity-fields-container">
                                    {
                                        entity.FieldList!.map((field) => (
                                            <div className="area-entity-field-item-container">
                                                <div className="area-entity-field-item">
                                                    <div className="area-entity-data"><span className="area-entity-label-field">({props.showFieldStats(field.code)}) {field.name}</span></div>
                                                    <span onClick={() => handleLabelListStatus(field.code!, 'LabelList_Counter_')} className="material-symbols-outlined  arrow-field-list">
                                                    arrow_drop_up
                                                    </span>
                                                </div>
                                                <div  id= {'LabelList_Counter_' + field.code?.toString()} className="area-entity-fields-labels-container">
                                                {
                                                    props.getPlaceNameStats(field.code).map((stat) => (
                                                        <div id={field.code + stat.placeName} className="area-entity-field-label-item">
                                                            <div className="area-entity-data"><span onClick={() => props.handleLabelSelected(stat.placeName, field.code, entity.Code)} className="area-entity-label-font">({stat.count}) {stat.placeName}</span></div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            
                                        
                                            
                                        </div>
                                        ))
                                    }
                                    
                                </div>
                                
                                
                            </div>
                    ))
                }
            </div>
            <div className="tool-handle"></div>
        </animated.div>
      
    );
}